import apiFetch from '../apiFetch'

export default function (newPassword, token) {
  return apiFetch({ endPoint: 'login/resetpassword', method: 'POST', body: newPassword, token: token })
}
